/* Funcao padrao para gerar datas no app */

import moment from 'moment-timezone';

export default function geraData(date = new Date(), mascara = 'YYYY-MM-DD HH:mm:ss.SSS', timezone = 'America/Sao_Paulo') {
  if (!date) {
    return null;
  }
  return moment(date).tz(timezone).format(mascara);
}

/**
 * Converte data para o formato ISO UTC da nuvem (ex: 2026-10-05T20:30:00.000Z).
 * Se for string legada sem fuso gerada no fuso de SP, compensa as 3 horas de diferença.
 */
export function geraDataNuvem(date = new Date()) {
  if (!date) return null;
  if (typeof date === 'string') {
    if (date.startsWith('1997-01-01')) return '1997-01-01 13:00:00.000';
    if (date.endsWith('Z') || date.includes('+')) {
      return moment.utc(date).toISOString();
    }
    return moment.tz(date, 'America/Sao_Paulo').utc().toISOString();
  }
  return moment.utc(date).toISOString();
}

/**
 * Formata a data para a consulta no banco da nuvem (POST all/itemsaatualizar).
 * Retorna 'YYYY-MM-DD HH:mm:ss.SSS' em UTC para comparacao com o timestamp da nuvem.
 */
export function formatarDataParaConsultaNuvem(date) {
  if (!date || (typeof date === 'string' && date.startsWith('1997-01-01'))) {
    return '1997-01-01 13:00:00.000';
  }
  if (typeof date === 'string') {
    if (date.endsWith('Z') || date.includes('+')) {
      return moment.utc(date).format('YYYY-MM-DD HH:mm:ss.SSS');
    }
    return moment.tz(date, 'America/Sao_Paulo').utc().format('YYYY-MM-DD HH:mm:ss.SSS');
  }
  return moment.utc(date).format('YYYY-MM-DD HH:mm:ss.SSS');
}
